import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';

@Component({
  imports: [CommonModule],
  standalone: true,

  selector: 'app-device-settings-header',
  templateUrl: './device-settings-header.component.html',
  styleUrls: ['./device-settings-header.component.scss'],
})
export class DeviceSettingsHeaderComponent {
  @Input({ required: true }) title!: string | undefined;
}
